export interface LegendProvider {
    getLegendSvg(): Promise<string | "">;
}

export class HttpLegendProvider implements LegendProvider {
    constructor(private url: string) {}
    async getLegendSvg(): Promise<string | ""> {
        try {
            const res = await fetch(this.url);
            if (res.ok) return await res.text();
        } catch {}
        return "";
    }
}
